"use client";

import React from "react";
import { toggleCategory, type CategoryNode } from "@/lib/category-filter";
import type { ShopFilters } from "@/lib/shop-filters";

// De rij categorieblokken direct onder de introtekst (MOW-CATEGORIEFILTER-OKT26): op /shop de hoofdcategorieën,
// op een categoriepagina de onderliggende categorieën. Elk blok is een schakelknop die dezelfde keuze zet als
// het selectievakje in het filterpaneel, dus meerdere tegelijk en altijd gelijk aan wat het paneel toont.
// Het zijn knoppen, geen links: de pagina's zelf blijven bereikbaar via het menu, de tegels en de sitemap.

interface Props {
  blocks: ReadonlyArray<CategoryNode>;
  filters: ShopFilters;
  onChange: (f: ShopFilters) => void;
  /** De volledige boom, zodat een ouder zijn kinderen uit de keuze haalt; null zolang het menu niet binnen is. */
  tree: ReadonlyArray<CategoryNode> | null;
  /** Tijdens het laden van de lijst kan een keuze het adres van een gedeelde link overschrijven; dan niet te kiezen. */
  disabled?: boolean;
}

export default function CategoryBlocks({ blocks, filters, onChange, tree, disabled = false }: Props) {
  if (blocks.length === 0) return null;
  return (
    <div className="category-blocks" role="group" aria-label="Filter op categorie">
      {blocks.map((b) => {
        const actief = filters.categories.includes(b.slug);
        return (
          <button
            key={b.slug}
            type="button"
            className={`category-block${actief ? " category-block-active" : ""}`}
            aria-pressed={actief}
            disabled={disabled}
            onClick={() => onChange({ ...filters, categories: toggleCategory(filters.categories, b.slug, tree) })}
          >
            {b.label}
          </button>
        );
      })}
    </div>
  );
}
